export default {
    title: [
        v => !! v || 'Judul tryout harus diisi'
    ],

    minute_limit: [
        v => !! v || 'Waktu pengerjaan harus diisi',
        v => ! isNaN(v) || 'Waktu pengerjaan harus angka dalam menit'
    ],

    released_date: [
        v => !! v || 'Tanggal rilis harus diisi'
    ],

    released_time: [
        v => !! v || 'Waktu rilis harus diisi'
    ],
}
